<template>
  <div class="page">
    <div class="headerNav">
      <div class="nav">
        <div class="nav_content">邀请新用户</div>
      </div>
      <div class="nav-left" @click="goBack"><img src="../../assets/images/left-w.png" alt="" /></div>
    </div>
    <div class="title_1">
      <img src="../../assets/images/zi.png" alt="" />
    </div>
    <div class="group_1">
      <div class="content">
        <div style="display: flex; justify-content: center; width: 100%; position: absolute; top: -9px; left: 0; right: 0">
          <div class="icon">积分规则</div>
        </div>
        邀请好友加入平台，轻松赚积分，可兑换好礼、抵扣课程费用，福利多多！以下是详细规则：<br />
        <span class="text_1">一、参与条件</span> ​<br />
        所有平台注册用户均可参与，分享平台链接邀请好友，开启积分赚取之旅。<br />
        <span class="text_1">二、新用户判定</span> ​<br />
        系统精准判定：新用户指从未在本平台注册过的用户。若好友已注册，邀请人无法获得积分。<br />
        <span class="text_1">三、邀请步骤​</span> <br />
        点击底部“获取链接”按钮将链接分享给好友（微信、QQ、短信等均可）。​<br />
        好友通过链接注册登录，即绑定为你的被邀请用户，好友在平台的每一笔消费你都可以获得积分。<br />
        <span class="text_1">四、积分获取规则</span> ​<br />
        新用户购买产品并支付成功，邀请人获相应积分，​积分与好友消费金额等额，如好友消费 180 元，邀请人得 180 积分。​<br />
        无时间限制，好友任何时候购买支付成功，邀请人均可获积分。​好友订单退款，邀请人对应积分将被扣除。<br />
        好友支付成功后，24 小时内发放积分。特殊情况延迟到账，平台会发通知说明。<br />
        <span class="text_1">五、积分价值、用法</span> <br />
        ​ 30 积分 = 1 元，积少成多可攒“小财富”。​积分可在平台商城兑换精美商品兑换的商品不退不换。​
        购买课程时抵扣现金（具体规则按平台规定）。
        <br />
        在平台 “学习中心 — 我的积分” 查看积分明细（获取、使用、过期等）<br />
        <span class="text_1"> 六、其他说明</span>​<br />
        平台监控邀请行为，不正当手段（虚假注册、恶意下单等）获取积分者，将被取消资格，情节严重者追究法律责任。​<br />
        本规则最终解释权归平台，调整修改会通过公告通知，请注意查看。
      </div>
    </div>
   <!-- Vue 模板 -->
    <div class="btn"><button @click="handleInviteClick" class="btn_1">
  {{ copying ? '正在生成...' : (copied ? '已复制！' : '邀请好友') }}
</button></div>


  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { getShareUrl } from '../../api/index';
import { Dialog } from 'vant';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      shareUrl: '',
       copying: false,
    copied: false
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    goBack() {
      this.$router.push({
        path: '/'
      });
    },
async handleInviteClick() {
  if (this.copied) {
    this.copied = false;
    return;
  }

  this.copying = true;
  try {
    const res = await getShareUrl();
    if (res.data.code === 200) {
      const shareUrl = res.data.msg;

      const success = this.syncCopy(shareUrl);

      if (success) {
        this.$utils.showToast('复制成功！');
        this.copied = true;
        setTimeout(() => { this.copied = false; }, 2000);
      } else {
       Dialog.confirm({
            title: '温馨提示',
            message: '链接已生成，请点击按钮复制链接',
            confirmButtonColor: '#2A70F2',
            confirmButtonText: '确认复制'
          })
            .then(() => {
             this.syncCopy(shareUrl);
        this.$utils.showToast('复制成功！');

            })
            .catch(() => {
            });
        
      }
    } else {
    //  this.$utils.showToast('获取失败');
    }
  } catch (err) {
    //this.$utils.showToast('网络错误');
  } finally {
    this.copying = false;
  }
},

 syncCopy(text) {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  textarea.style.left = '-9999px';
  textarea.style.top = '-9999px';
  document.body.appendChild(textarea);

  textarea.focus();
  textarea.select();
  textarea.setSelectionRange(0, text.length);

  try {
    const result = document.execCommand('copy');
    document.body.removeChild(textarea);
    return result;
  } catch (err) {
    document.body.removeChild(textarea);
    return false;
  }
},

  showManualCopy(text) {
    this.$utils.showToast('请长按下方链接复制');
    const input = document.createElement('input');
    input.value = text;
    input.readOnly = true;
    input.style.position = 'fixed';
    input.style.left = '50%';
    input.style.top = '50%';
    input.style.transform = 'translate(-50%, -50%)';
    input.style.padding = '10px';
    input.style.fontSize = '16px';
    input.style.zIndex = '9999';
    document.body.appendChild(input);
    input.focus();
    input.select();

    setTimeout(() => {
      document.body.removeChild(input);
    }, 3000);
  }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
.page {
  background-image: url('../../assets/images/newBg.png');

  background-size: 100% 100%;
  overflow-y: scroll;
  margin-bottom: 60px;
  background-repeat: no-repeat;
  width: 100%;
  min-height: 100vh;
  padding: 75px 13px 0 13px;
}
.headerNav {
  position: fixed;
  top: 0;
  width: 100%;
  height: 46px;
  border-radius: 0px 0px 0px 0px;
  z-index: 99;
}
.nav {
  padding: 0 15px;
  height: 46px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.nav-left {
  position: absolute;
  top: 15px;
  left: 0;
  img {
    width: 18px;
    height: 18px;
  }
}
.nav_content {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 17px;
  color: #ffffff;
}
.title_1 {
  height: 30px;
  width: 100%;

  img {
    height: 30px;
    width: 100%;
  }
}
.group_1 {
  padding: 41px 19px 19px 19px;
  width: 100%;
  height: auto;
  background: linear-gradient(180deg, #fefbe0 0%, #fffffe 100%);
  border-radius: 10px 10px 10px 10px;
  border: 2px solid #ffffff;
  margin-top: 30px;
  position: relative;
  .icon {
    // position: absolute;
    // top: -8px;
    // left: 31%;
    // right: 98px;
    width: 149px;
    background-size: 100% 100%;
    height: 37px;
    background-repeat: no-repeat;
    background-image: url('../../assets/images/icon_88.png');
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    line-height: 37px;
  }
}
.content {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
}
.text_1 {
  color: rgba(255, 136, 51, 1);
}
.btn {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  margin-top: 22px;
  height: 56px;
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  .btn_1 {
    border: 0;
    width: 330px;
    height: 42px;
    background: #ff8833;
    border-radius: 8px 8px 8px 8px;
    text-align: center;
    line-height: 42px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 15px;
    color: #ffffff;
  }
}
</style>
